export default __webpack_public_path__ + "media/images/svg/graphic-bg-4-bcd19c051a2a32e8c24d315fea3c56d4.svg";